export const getServer = () => process.env.REACT_APP_API_URL;
